import GridShape from '../../components/common/GridShape';
import ThemeTogglerTwo from '../../components/common/ThemeTogglerTwo';

export default function AuthLayout({ children }) {
  return (
    <div className="relative z-1 bg-white p-4 dark:bg-gray-900 sm:p-6 md:p-8 lg:p-0">
      <div className="relative flex min-h-[100dvh] w-full flex-col justify-center dark:bg-gray-900 lg:flex-row lg:p-0">
        <div className="order-2 flex w-full flex-1 flex-col lg:order-1 lg:w-1/2 lg:max-w-none lg:justify-center lg:px-8 xl:px-12 2xl:px-16">
          {children}
        </div>
        <div className="order-1 flex h-auto min-h-[140px] w-full shrink-0 bg-brand-950 dark:bg-white/5 sm:min-h-[180px] lg:order-2 lg:min-h-[100dvh] lg:w-1/2">
          <div className="relative z-1 flex w-full flex-col items-center justify-center gap-4 px-6 py-10 sm:gap-5 sm:py-12 md:py-16 lg:py-8 xl:gap-6">
            <GridShape />
            <div className="relative z-1 flex max-w-md flex-col items-center gap-4 text-center sm:max-w-lg sm:gap-5 md:max-w-xl">
              <div className="flex flex-col items-center gap-3 sm:flex-row sm:items-center sm:justify-center sm:gap-4 md:gap-6">
               
               
                <img
                  src="/images/BhashaSetu.webp"
                  alt="BhāshāSetu"
                  width={400}
                  height={56}
                  className="h-6 w-auto max-w-[min(200px,70vw)] object-contain sm:h-11 md:h-22"
                />
                
               

                <img
                  src="/images/ARTPARK.webp"
                  alt="ARTPARK"
                  width={400}
                  height={56}
                  className="h-10 w-auto max-w-[min(200px,70vw)] object-contain sm:h-11 md:h-10"
                />
              </div>
              <h2 className="text-xl font-semibold text-white sm:text-2xl md:text-3xl lg:text-2xl xl:text-3xl">
                QC Lite
              </h2>
              <p className="max-w-sm text-sm text-gray-300 dark:text-white/55 sm:max-w-md sm:text-base md:text-lg lg:text-sm xl:text-base">
                Tool
              </p>
            </div>
          </div>
        </div>
        <div className="fixed bottom-4 right-4 z-50 sm:bottom-6 sm:right-6">
          <ThemeTogglerTwo />
        </div>
      </div>
    </div>
  );
}
